const SET_LANGUAGE = 'infra/SET_LANGUAGE';

export default {
  SET_LANGUAGE,
};



// WEBPACK FOOTER //
// ./src/infraMonitor/localization/types.js